import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { TextBlock } from '../../../Atoms/Text';

interface PanelHeaderProps {
  title: string;
  description: ReactNode;
  className?: string;
}

/** A step tab's title and the line beneath it. */
export const PanelHeader = ({ title, description, className }: PanelHeaderProps) => (
  <Box className={className}>
    <TextBlock
      size="lg"
      weight="semibold"
      color="grey8">
      {title}
    </TextBlock>
    <TextBlock
      size="sm14"
      color="grey6">
      {description}
    </TextBlock>
  </Box>
);
